export default {"src":"/_next/static/media/sports11.d55dffa3.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};